module.exports = __webpack_public_path__ + "static/media/woman-holding-tomatoes-3213283.14b8e31d.jpg";